<script setup lang="ts">
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  nodes: null
});
defineEmits(["update:nodes"]);
__MACROS_useVModel("nodes")
</script>

<template>
  <div class="w-full">
    <nav class="flex" aria-label="Breadcrumb">
      <ol class="inline-flex items-center text-sm font-medium space-x-1 md:space-x-2">
        <li class="inline-flex items-center">
          <router-link class="hover:text-primary-600 inline-flex items-center text-gray-700 dark:text-gray-300 dark:hover:text-white" to="/">
            <div class="mr-2.5 h-5 w-5 text-gray-400" i-mdi-house />
            Startseite
          </router-link>
        </li>

        <li v-for="(node, index) in nodes" :key="node">
          <TheBreadcrumb :route="node" :is-last="index === nodes.length - 1" />
        </li>
      </ol>
    </nav>
  </div>
</template>
